<template>
  <div class="kpt-column-editor-context-pane">
    <header class="kpt-context-pane-header">
      <h4><strong><span class="is-capitalized">{{activeTableContext}}</span> Table Settings</strong></h4>
      <b-icon icon="times-circle" @click.native="close"></b-icon>
    </header>
    <main class="kpt-context-pane-main">
      <b-field label="Items per Page">
        <b-select v-model="pageSize" placeholder="Items per Page">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </b-select>
      </b-field>
      <b-field label="Edit Columns">
        <b-table
          :data="reorderedColumns"
          :columns="columns"
          checkable
          :checked-rows.sync="selectedColumns"
          :is-row-checkable="(row) => rowCheckable(row)"
          draggable
          @dragstart="dragstart"
          @drop="drop"
          @dragover="dragover"
          @dragleave="dragleave"
          >
        </b-table>
      </b-field>
    </main>
    <footer class="kpt-context-pane-footer">
      <div class="buttons">
        <b-button type="is-primary" @click="applyChanges">Apply Changes</b-button>
      </div>
    </footer>
  </div>
</template>
<script>
/* eslint-disable no-param-reassign */
export default {
  data() {
    return {
      pageSize: 25,
      allColumns: [],
      selectedColumns: [],
      columns: [{ field: 'value', label: 'Column' }],
      draggingRow: null,
      draggingRowIndex: null,
      reorderedColumns: []
    }
  },
  methods: {
    applyChanges() {
      // get existing list settings
      const listSettings = this.$store.state.user.settings.userListSettings;
      // find the remotes table to modify
      let tableSettings = listSettings.find(r => r.table == this.activeTableContext);
      // find the hidden columns
      const hiddenColumns = this.reorderedColumns.filter(d => this.selectedColumns.indexOf(d) == -1);
      // if found, modify
      if (tableSettings) {
        tableSettings.pageSize = this.pageSize;
        tableSettings.hiddenColumns = hiddenColumns;
        tableSettings.reorderedColumns = this.reorderedColumns;
      } else {
        // otherwise create new settings
        tableSettings = {
          pageSize: this.pageSize,
          hiddenColumns,
          table: this.activeTableContext,
          reorderedColumns: this.reorderedColumns
        }
      }
      // find the index where this table resides in the list settings
      let idx = listSettings.findIndex(t => t.table == this.activeTableContext);
      // if index is -1, means user has no settings
      if (idx == -1) idx = listSettings.length;
      // overwrite the index
      listSettings[idx] = tableSettings;
      // save settings
      this.$store.dispatch('updateSetting', { key: 'listSettings', value: listSettings });
      // push to vuex
      const columnsToPush = this.allColumns.filter(d => hiddenColumns.find(z => d.key == z.key) == null)
      this.$store.commit('updateActiveTableVisibleColumns', columnsToPush);
      this.$store.commit('updateActiveTablePageSize', this.pageSize);
      this.$store.commit('updateActiveTableReorderedColumns', this.reorderedColumns);
      this.close();
    },
    dragstart(payload) {
      this.draggingRow = payload.row;
      this.draggingRowIndex = payload.index;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.target.closest('tr').classList.add('is-current-sort');
      // change columns' array index with dragging one, so it apears where it droped to see 
      this.reorderedColumns.splice(payload.index, 0, this.reorderedColumns.splice(this.draggingRowIndex, 1)[0]);
    },
    fillTable() {
      const vr = this.reorderedColumns.filter(r => this.activeTableVisibleColumns.find(a => a.key == r.key) != null);
      this.selectedColumns = this.selectedColumns.concat(vr);
    },
    rowCheckable(row) {
      if (this.activeTableContext.toLowerCase() == 'remotes' && (row.value == 'Name' || row.value == 'Account' || row.value == 'Billed Account')) { return false; }
      if (this.activeTableContext.toLowerCase() == 'devices' && row.value == 'Serial') { return false; }
      if (this.activeTableContext.toLowerCase() == 'subscriptions' && row.value == 'KPC') { return false; }
      return true; 
    },
    fetchTableSetting(tableName, settingName) {
      const table = this.$store.state.user.settings.userListSettings.find(r => r.table == tableName);
      return table ? table[settingName] : null;
    }
  },
  created() {
    // clone the table
    const userListSettingReorderedColumns = this.fetchTableSetting(this.activeTableContext, 'reorderedColumns');
    if (userListSettingReorderedColumns && userListSettingReorderedColumns.length > 0) {
      userListSettingReorderedColumns.forEach(element => {
        this.reorderedColumns.push(element);
      });
    } else {
      this.activeTableColumns.forEach(element => {
        this.reorderedColumns.push(element);
      });
    }
    this.allColumns = this.activeTableColumns;
    this.pageSize = this.activeTablePageSize;
    this.context = this.activeTableContext;
    this.fillTable();
  },
  props: {
    close: Function
  },
  computed: {
    activeTableColumns() {
      return this.$store.state.system.activeTableColumns;
    },
    activeTablePageSize() {
      return this.$store.state.system.activeTablePageSize;
    },
    activeTableVisibleColumns() {
      return this.$store.state.system.activeTableVisibleColumns;
    },
    activeTableContext() {
      return this.$store.state.system.activeTableContext;
    },
    activeTableReorderedColumns() {
      return this.$store.state.system.activeTableReorderedColumns;
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-column-editor-context-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 425px;

  .kpt-feedback-icons {
    .feedback-icon {
      margin-right: 8px;
    }
  }
}
</style>
